// All saved cooking material, grouped by kind.
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNav } from '../navigation';
import { createBlank, type CreatableKind } from '../store/library';
import { showMenu } from '../components/Dialogs';
import { IconButton, ListItem, Screen, Section } from '../components/ui';
import { useHeader } from '../hooks';
import type { IconName } from '../components/Icon';

const CREATE: { kind: CreatableKind; icon: IconName; route: 'Recipe' | 'Cookbook' | 'Mealplan' | 'Ingredient' | 'Utensil' | 'Unit'; label: string }[] = [
  { kind: 'recipes', icon: 'recipe', route: 'Recipe', label: 'kinds.recipe' },
  { kind: 'mealplans', icon: 'mealplan', route: 'Mealplan', label: 'kinds.mealplan' },
  { kind: 'cookbooks', icon: 'cookbook', route: 'Cookbook', label: 'kinds.cookbook' },
  { kind: 'ingredients', icon: 'ingredient', route: 'Ingredient', label: 'kinds.ingredient' },
  { kind: 'utensils', icon: 'utensil', route: 'Utensil', label: 'kinds.utensil' },
  { kind: 'units', icon: 'unit', route: 'Unit', label: 'kinds.unit' },
];

export function useCreateMenu() {
  const { t } = useTranslation();
  const nav = useNav();
  return (only?: CreatableKind) => showMenu(
    CREATE.filter(c => !only || c.kind === only).map(c => ({
      label: `${t('library.create')}: ${t(c.label as 'kinds.recipe')}`,
      icon: c.icon,
      onPress: () => {
        const id = createBlank(c.kind, t('library.newItem', { kind: t(c.label as 'kinds.recipe') }));
        nav.navigate(c.route, { id, edit: true });
      },
    })),
    t('library.create'),
  );
}

export function LibraryOverview() {
  const { t } = useTranslation();
  const nav = useNav();
  return <>
    <Section>
      <ListItem title={t('kinds.recipes')} icon="recipe" onPress={() => nav.navigate('AllRecipes')} />
      <ListItem title={t('kinds.mealplans')} icon="mealplan" onPress={() => nav.navigate('EntityList', { kind: 'mealplans' })} />
      <ListItem title={t('kinds.cookbooks')} icon="cookbook" onPress={() => nav.navigate('EntityList', { kind: 'cookbooks' })} />
    </Section>
    <Section>
      <ListItem title={t('kinds.ingredients')} icon="ingredient" onPress={() => nav.navigate('EntityList', { kind: 'ingredients' })} />
      <ListItem title={t('kinds.utensils')} icon="utensil" onPress={() => nav.navigate('EntityList', { kind: 'utensils' })} />
      <ListItem title={t('kinds.units')} icon="unit" onPress={() => nav.navigate('EntityList', { kind: 'units' })} />
    </Section>
  </>;
}

export default function LibraryScreen() {
  const { t } = useTranslation();
  const create = useCreateMenu();
  useHeader({ title: '', headerRight: () => <IconButton icon="plus" label={t('library.create')} onPress={() => create()} /> }, [t]);
  return <Screen><LibraryOverview /></Screen>;
}
